import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { Erp1cAnalyticDimensionKeyEnum } from '@zaoblako/shared/modules/catalog/enums/erp-1c-analytic-dimension-key.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string represenations of {@link Erp1cAnalyticDimensionKeyEnum} enumeration values */
export const Erp1cAnalyticDimensionKeyEnumI18n: EnumI18nInterface<Erp1cAnalyticDimensionKeyEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [Erp1cAnalyticDimensionKeyEnum.OTHER_INCOME_EXPENSE]: 'Прочие доходы и расходы',
    [Erp1cAnalyticDimensionKeyEnum.WAREHOUSE]: 'Склады (места хранения)',
    [Erp1cAnalyticDimensionKeyEnum.CASH_FLOW_ITEM]: 'Статьи движения денежных средств',
    [Erp1cAnalyticDimensionKeyEnum.COST_ITEM]: 'Статьи затрат',
    [Erp1cAnalyticDimensionKeyEnum.ITEM]: 'Номенклатура',
    [Erp1cAnalyticDimensionKeyEnum.CONTRACT]: 'Договоры',
    [Erp1cAnalyticDimensionKeyEnum.COUNTERPARTY]: 'Контрагенты',
  },
  [I18nLocalesEnum.EN_US]: {
    [Erp1cAnalyticDimensionKeyEnum.OTHER_INCOME_EXPENSE]: 'Other financial flows',
    [Erp1cAnalyticDimensionKeyEnum.WAREHOUSE]: 'Warehouses',
    [Erp1cAnalyticDimensionKeyEnum.CASH_FLOW_ITEM]: 'Cash/Flow items',
    [Erp1cAnalyticDimensionKeyEnum.COST_ITEM]: 'Cost items',
    [Erp1cAnalyticDimensionKeyEnum.ITEM]: 'Items',
    [Erp1cAnalyticDimensionKeyEnum.CONTRACT]: 'Contracts',
    [Erp1cAnalyticDimensionKeyEnum.COUNTERPARTY]: 'Counterparties',
  },
};
